// _components/preloader.js
import dsnGrid from './dsnGrid';

let _promise = null;
let _resolve = null;
let _finished = false;
let _fallbackTimer = null;
let _loadBound = false;

const CONFIG = {
  root: '.preloader',
  timeoutMs: 8000,
  ns: '.preloaderNS',
};

const get$ = () => window.jQuery || window.$;
const hasGSAP = () => typeof window.gsap !== 'undefined';

function finish() {
  if (_finished) return;
  _finished = true;

  clearTimeout(_fallbackTimer);
  _fallbackTimer = null;

  const $ = get$?.();
  if ($) {
    const $root = $(CONFIG.root);
    if ($root.length && !$root.hasClass('d-none')) $root.addClass('d-none');
  }

  window.dispatchEvent(new Event('preloader:done'));

  if (typeof _resolve === 'function') {
    _resolve();
    _resolve = null;
  }
}

function preloader() {
  if (_finished) return Promise.resolve();
  if (_promise) return _promise;

  const $ = get$?.();
  if (!$ || !hasGSAP()) {
    _finished = true;
    return Promise.resolve();
  }

  const $root = $(CONFIG.root);
  if (!$root.length) {
    _finished = true;
    return Promise.resolve();
  }

  const $block = $root.find('.preloader-block');
  const $num = $block.find('.percent');
  const $title = $block.find('.title');
  const $loading = $block.find('.loading');
  const $bar = $root.find('.preloader-bar');
  const $prog = $bar.find('.preloader-progress');
  const $after = $root.find('.preloader-after');
  const $before = $root.find('.preloader-before');

  _promise = new Promise((resolve) => {
    _resolve = resolve;

    // （元の）擬似進捗
    const tickTimer = dsnGrid.pageLoad(0, 100, 300, (val) => {
      $num.text(val);
      $prog.css('width', val / 10 + '%');
    });

    // フォールバック
    _fallbackTimer = setTimeout(finish, CONFIG.timeoutMs);

    // window.load で締めのアニメへ（多重バインド防止）
    if (!_loadBound) {
      _loadBound = true;

      $(window)
        .off('load' + CONFIG.ns)
        .on('load' + CONFIG.ns, function () {
          clearInterval(tickTimer);

          gsap.fromTo(
            $prog,
            { width: '95%' },
            {
              duration: 0.5,
              width: '100%',
              onUpdate() {
                const f = ($prog.width() / $prog.parent().width()) * 100;
                $num.text(parseInt(f, 10));
              },
              onComplete() {
                gsap.to($bar, { duration: 0.5, left: '100%' });
                gsap.to($title, { duration: 1, autoAlpha: 0, y: -100 });
                gsap.to($loading, { duration: 1, autoAlpha: 0, y: 100 });
                gsap.to($num, { duration: 1, autoAlpha: 0 });

                gsap.to($before, { duration: 1, y: '-100%', delay: 0.7 });
                gsap.to($after, {
                  duration: 1,
                  y: '100%',
                  delay: 0.7,
                  onComplete: finish,
                });
              },
            }
          );
        });
    }
  });

  return _promise;
}

function stopload() {
  finish();
}

function init(options = {}) {
  Object.assign(CONFIG, options);
  return preloader();
}

export default { init, preloader, stopload };
